// @flow

// export const TENANT = '1';
export const TENANT = '2';
